// extracted by mini-css-extract-plugin
export default {"accordion_root":"vba","accordion_summary":"wba","accordion_details_root":"xba","expand_icon":"yba","rotate_arrow":"zba","info_item":"Aba","ingredient":"Bba","title":"Cba","product":"Eba","img":"Fba"};
    if(module.hot) {
      // 1714422958264
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  